import { useMemo } from 'react';
import { STORAGE_UID_KEY } from '../constants';

/** 5d.1: 首访时生成并持久化匿名用户 ID（localStorage） */
export function useLocalUid(): string {
  return useMemo(() => {
    try {
      let uid = localStorage.getItem(STORAGE_UID_KEY);
      if (!uid) {
        uid = 'uid_' + Math.random().toString(36).slice(2) + '_' + Date.now().toString(36);
        localStorage.setItem(STORAGE_UID_KEY, uid);
      }
      return uid;
    } catch {
      return 'uid_' + Date.now();
    }
  }, []);
}
